export default function BlogSection() {
  const articles = [
    {
      title: "Как стать оператором чата с нуля: пошаговая инструкция",
      category: "Карьера",
      readTime: "7 мин чтения",
      date: "12 марта 2024",
      desc: "Рассказываем, как пройти путь от новичка до оператора чата за одну неделю. Что нужно знать, как проходит обучение и когда первые выплаты.",
      img: "https://readdy.ai/api/search-image?query=person%20learning%20chat%20support%20skills%20on%20laptop%20at%20home%20desk%2C%20bright%20modern%20home%20office%2C%20training%20manual%20and%20chat%20interface%20visible%2C%20blue%20white%20minimalist%20interior&width=500&height=300&seq=ws-blog1&orientation=landscape",
    },
    {
      title: "380₽/час: сколько реально зарабатывает оператор чата",
      category: "Зарплата",
      readTime: "5 мин чтения",
      date: "28 февраля 2024",
      desc: "Честный разбор: сколько получается в месяц при разных графиках. Расчёты для смен 4/2, 5/2 и подработки по вечерам.",
      img: "https://readdy.ai/api/search-image?query=calculator%20and%20money%20on%20a%20desk%20with%20chat%20support%20screen%20on%20laptop%2C%20bright%20minimalist%20workspace%20blue%20white%20clean%20modern%20desk%2C%20salary%20calculation%20concept&width=500&height=300&seq=ws-blog2&orientation=landscape",
    },
    {
      title: "Чем оператор чата отличается от оператора колл-центра",
      category: "Советы",
      readTime: "6 мин чтения",
      date: "15 февраля 2024",
      desc: "Многие путают, но это разные профессии. Объясняем ключевые отличия, плюсы работы в чатах и почему это комфортнее, чем звонки.",
      img: "https://readdy.ai/api/search-image?query=two%20different%20work%20setups%20comparison%20chat%20support%20vs%20call%20center%2C%20person%20happily%20typing%20on%20laptop%20chat%20vs%20person%20on%20phone%20headset%2C%20bright%20modern%20blue%20white%20workspace%20split%20screen&width=500&height=300&seq=ws-blog3&orientation=landscape",
    },
  ];

  return (
    <section id="blog" className="relative py-24 lg:py-32 overflow-hidden bg-background-50">
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full text-xs font-semibold tracking-widest uppercase mb-4 bg-primary-100 text-primary-700">
            Блог
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground-950 mb-5">
            Полезные статьи для{" "}
            <span className="text-primary-500">операторов чата</span>
          </h2>
          <p className="text-foreground-600 text-base lg:text-lg max-w-2xl mx-auto leading-relaxed">
            Делимся опытом, нюансами профессии и реальными историями из жизни операторов чата.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {articles.map((article) => (
            <article
              key={article.title}
              className="rounded-2xl overflow-hidden bg-background-50 border border-primary-100 shadow-sm transition-all duration-300 hover:-translate-y-2 hover:shadow-xl cursor-pointer group"
            >
              <div className="w-full h-44 overflow-hidden">
                <img
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  src={article.img}
                />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-3 mb-3">
                  <span className="px-3 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-700">
                    {article.category}
                  </span>
                  <span className="text-foreground-500 text-xs">{article.readTime}</span>
                </div>
                <h3 className="text-foreground-950 font-semibold text-base leading-snug mb-3 group-hover:text-primary-500 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed mb-4">
                  {article.desc}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-foreground-500 text-xs">{article.date}</span>
                  <span className="text-primary-500 text-xs font-medium flex items-center gap-1">
                    Читать <i className="ri-arrow-right-line" />
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}